'use strict';

document.addEventListener("DOMContentLoaded", () => {
  const coursesSlider = new Swiper('.js-coursesTiles', {
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1201: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1301: {
        slidesPerView: 3,
        spaceBetween: 44,
      },
    },
  });
});
